import React, {useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'
import { connect } from 'react-redux'

const MAX_NSS_LENGTH = 11

const NssInput = ({ student, nssRef }) => {
  const { numero_de_seguro_social } = student.info
  const [nss, setNss] = useState('')
  
  const documento = student.documents.filter( document => document.slug === 'registro-imss')[0]
  
  useEffect(() => {
    setNss(numero_de_seguro_social)
  }, [])

  return(
    <Form.Control 
      ref={nssRef}
      type="text"
      value={nss}
      onChange={(e) => setNss(e.target.value)}
      maxLength={MAX_NSS_LENGTH}
      disabled={documento.documento && documento.documento.aceptado} 
      placeholder="Número de Seguro Social"
    />
  )
}

export default connect((state) => ({student: state.unenrolledStudent}))(NssInput)